export const ENVIRONMENT = {
  LOCAL: 'localDev',
  DEVELOPMENT: 'development',
};

export const HTTP_METHODS = {
  DELETE: 'DELETE',
  GET: 'GET',
  OPTIONS: 'OPTIONS',
  PATCH: 'PATCH',
  POST: 'POST',
  PUT: 'PUT',
};

export const modelNameMapping = {
  ms: 'Model S',
  m3: 'Model 3',
  mx: 'Model X',
  my: 'Model Y',
  rd: 'Roadster',
};

export const docTypes = {
  image: 'image/*',
  pdf: 'application/pdf',
  pdfName: 'PDF',
};

export const numbers = {
  requiredDocNumber: 3,
  requiredBusinessDocNumber: 5,
};

export const payx = {
  SOURCE: 'SUPERCHARGE',
};

export const registrationType = {
  BUSINESS: 'business',
  PERSONAL: 'personal',
};

export const emeaRegion = ['REEU', 'REME', 'REAU'];

export const errorType = {
  INVALID_VEHICLE_NAME: 'INVALID_VEHICLE_NAME', // Todo: remove this when Apollo migration is done
  FAILED_CAR_NAME_CHECK: 'FAILED_CAR_NAME_CHECK',
};
